import { Loader } from '@scality/core-ui';
import type React from 'react';
import styled from 'styled-components';

/**
 * Centers its content in the available area. `$offsetHeader` clears the fixed navbar,
 * for areas that are not already inside a header-aware container (the dual panel is).
 */
export const CenteredContent = styled.div<{ $offsetHeader?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  ${({ $offsetHeader }) => $offsetHeader && 'margin-top: var(--header-height);'}
`;

/** Loading state for a whole content area. */
export const CenteredLoader: React.FC<{ offsetHeader?: boolean }> = ({ offsetHeader }) => (
  <CenteredContent $offsetHeader={offsetHeader}>
    <Loader size="large" />
  </CenteredContent>
);
